import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MemberProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberProfile","document":MemberProfileDocument}} as const;
export type MemberProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MemberProfileQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'username'>
  )> }
);

/**
 * __useMemberProfileQuery__
 *
 * To run a query within a React component, call `useMemberProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMemberProfileQuery(
  baseOptions: TrelloQueryHookOptions<
    MemberProfileQuery,
    MemberProfileQueryVariables
  > &
    (
      | { variables: MemberProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MemberProfileDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MemberProfileQuery,
    MemberProfileQueryVariables
  >(MemberProfileDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMemberProfileLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MemberProfileQuery,
    MemberProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberProfileQuery, MemberProfileQueryVariables>(
    MemberProfileDocument,
    options,
  );
}
export function useMemberProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        MemberProfileQuery,
        MemberProfileQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberProfileQuery,
    MemberProfileQueryVariables
  >(MemberProfileDocument, options);
}
export type MemberProfileQueryHookResult = ReturnType<
  typeof useMemberProfileQuery
>;
export type MemberProfileLazyQueryHookResult = ReturnType<
  typeof useMemberProfileLazyQuery
>;
export type MemberProfileSuspenseQueryHookResult = ReturnType<
  typeof useMemberProfileSuspenseQuery
>;
export type MemberProfileQueryResult = Apollo.QueryResult<
  MemberProfileQuery,
  MemberProfileQueryVariables
>;
